module.exports = __webpack_public_path__ + "static/media/error.7a4613e2.svg";